import { render, staticRenderFns } from "./ViewOrder.vue?vue&type=template&id=3870ccea&scoped=true"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewOrder.vue?vue&type=style&index=0&id=3870ccea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870ccea",
  null
  
)

export default component.exports